// Simplified image protection service
const ImageProtectionService = {
  PROTECTION_LEVELS: { LOW: 'low', MEDIUM: 'medium', HIGH: 'high' },

  protectImage(image, options = {}) {
    if (image) {
      image.setAttribute('data-protected', 'true');
      console.log('Image protection applied', options);
    }
  },

  initGlobalProtections() {
    console.log('Global image protections initialized');
  },
};

export default ImageProtectionService;
